
export { default as ProductDetail } from "./lib/ProductDetail/productDetail"
export { default as ProductDetailExtended } from "./lib/ProductDetailExtended/productDetailExtended"